export const locale = {
    lang: 'en',
    data: {
        'SAMPLE': {
            'HELLO': 'Welcome to the Toni.ai backend!'
        }
    }
};
